/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconTaskAlt/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconTaskAlt({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconTaskAlt",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconTaskAlt.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z2acPoU': alignSelf,'--mt-2-Z2acPoU': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2acPoU': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2acPoU': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2acPoU': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2acPoU': opacity,'--w-10-Z2acPoU': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2acPoU': typeof height === 'number' ? `${height}px` : height,'--a-7-Z2acPoU': isAnimated ? animation : "none",'--sd-8-Z2acPoU': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2acPoU': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconTaskAlt.SvgPath"
  data-view-path={viewPath}
 d="M22 5.18L10.59 16.6l-4.24-4.24 1.41-1.41 2.83 2.83 10-10L22 5.18zm-2.21 5.04c.13.57.21 1.17.21 1.78 0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8c1.58 0 3.04.46 4.28 1.25l1.44-1.44A9.9 9.9 0 0012 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-1.19-.22-2.33-.6-3.39l-1.61 1.61z"
 style={{'--f-12-Z2acPoU': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}